class DateTimeError extends Error {
  constructor(message) {
    super(message);
    this.name = 'DateTimeError';
  }
}

export const throwMessage = (func, klassName) => {
  return `${func} from ${klassName} is not defined`;
};

export default DateTimeError;
